(ns ui.view.survey.modals.mandatory-missing
  (:require [common.localization :as loc]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.modal.view :as modal]
            [ui.view.survey.modals.event :as event]
            [ui.view.survey.modals.sub :as sub]
            [ui.view.survey.sub :as survey-view-sub]
            [ui.components.alert.view :as alert]))

(defn body
  [survey-id lang]
  (let [missing-question-labels @(rf/subscribe [::survey-view-sub/missing-modal-questions survey-id])]
    [:div
     {:class "flex flex-col gap-4"}
     [alert/danger
      {}
      [:h4 
       {:class "text-md font-semibold"}
       (loc/tr :info-text-missing-answers nil lang)]]
     [:ul
      {:class "list-disc p-4 list-inside"}
      (->> missing-question-labels
           (map (fn [lbl]
                  ^{:key (str "missing-question-" lbl)}
                  [:li
                   {:class "py-2 text-semibold"}
                   lbl]))
           (doall))]]))

(defn footer
  [lang]
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row justify-content-start"}]
   [:div
    {:class "flex flex-row flex-auto content-stretch justify-content-end"}
    [button/primary-solid
     {:on-click (fn [_]
                  (rf/dispatch [::event/close-missing-modal]))}
     (loc/tr :close nil lang)]]])

(defn view
  [survey-id]
  (let [lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])]
    [modal/view
     {:visible? @(rf/subscribe [::sub/missing-modal-open?])
      :hide!    #(rf/dispatch [::event/close-missing-modal])
      :size     :full}
     (loc/tr :survey-num-fmt-modal-title nil lang)
     [body survey-id lang]
     [footer survey-id lang]]))

